import React from "react";
import styled, { keyframes } from "styled-components";
import colors from "../../../constants/colors";

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const fadeInOut = keyframes`
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.8; }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.05); opacity: 0.7; }
`;

const EmptyBoxContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const ServiceCardsGroup = styled.div`
  width: 85%;
  height: 85%;
  max-width: 170px;
  max-height: 170px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  animation: ${float} 3s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const ServiceCard = styled.div<{ $delay: number }>`
  width: 100%;
  height: 30%;
  background: linear-gradient(135deg, ${colors.PURPLE_LIGHTER} 0%, ${colors.PURPLE_LIGHT} 100%);
  border: 2px solid ${colors.PURPLE};
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 10px;
  opacity: 0.5;
  animation: ${fadeInOut} 3s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`;

const ServiceIcon = styled.div<{ $delay: number }>`
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 8px;
  background: ${colors.PURPLE};
  opacity: 0.4;
  animation: ${pulse} 2.5s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.5;
  }
`;

const ServiceDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ServiceLine = styled.div<{ $width: string; $delay: number }>`
  width: ${({ $width }) => $width};
  height: 3px;
  background: ${colors.PURPLE};
  border-radius: 2px;
  opacity: 0.4;
  animation: ${fadeInOut} 2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.5;
  }
`;

const EmptyBox: React.FC = () => {
  return (
    <EmptyBoxContainer>
      <ServiceCardsGroup>
        <ServiceCard $delay={0}>
          <ServiceIcon $delay={0} />
          <ServiceDetails>
            <ServiceLine $width="70%" $delay={0} />
            <ServiceLine $width="50%" $delay={0.2} />
          </ServiceDetails>
        </ServiceCard>
        <ServiceCard $delay={0.3}>
          <ServiceIcon $delay={0.3} />
          <ServiceDetails>
            <ServiceLine $width="65%" $delay={0.3} />
            <ServiceLine $width="45%" $delay={0.5} />
          </ServiceDetails>
        </ServiceCard>
        <ServiceCard $delay={0.6}>
          <ServiceIcon $delay={0.6} />
          <ServiceDetails>
            <ServiceLine $width="75%" $delay={0.6} />
            <ServiceLine $width="55%" $delay={0.8} />
          </ServiceDetails>
        </ServiceCard>
      </ServiceCardsGroup>
    </EmptyBoxContainer>
  );
};

export default EmptyBox;
